/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Typesofchanges3Inputs */

const id_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Perubahan`)
};

const ms_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Perubahan`)
};

const da_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typer af Ændringer`)
};

const de_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arten von Änderungen`)
};

const en_us2_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types of Changes`)
};

const es_es2_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de cambios`)
};

const es_mx2_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de cambios`)
};

const fil_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Uri ng Pagbabago`)
};

const fr_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types de modifications`)
};

const it_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipi di modifiche`)
};

const hu_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások típusai`)
};

const nl_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soorten wijzigingen`)
};

const no_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typer endringer`)
};

const pl_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodzaje zmian`)
};

const pt_br2_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types of Changes`)
};

const pt_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de alterações`)
};

const ro_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipuri de modificări`)
};

const fi_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutostyypit`)
};

const sv_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typer av ändringar`)
};

const vi_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại thay đổi`)
};

const tr_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Türleri`)
};

const cs_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typy změn`)
};

const bg_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видове промени`)
};

const ru_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типы изменений`)
};

const uk_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типи змін`)
};

const ar_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنواع التغييرات`)
};

const hi_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों के प्रकार`)
};

const th_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภทของการเปลี่ยนแปลง`)
};

const ja_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更のタイプ`)
};

const zh_cn2_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types of Changes`)
};

const zh_hant1_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types of Changes`)
};

const ko_components_changelogcharts_typesofchanges3 = /** @type {(inputs: Components_Changelogcharts_Typesofchanges3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types of Changes`)
};

/**
* | output |
* | --- |
* | "Types of Changes" |
*
* @param {Components_Changelogcharts_Typesofchanges3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_typesofchanges3 = /** @type {((inputs?: Components_Changelogcharts_Typesofchanges3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Typesofchanges3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "ms") return ms_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "da") return da_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "de") return de_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "fil") return fil_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "fr") return fr_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "it") return it_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "hu") return hu_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "nl") return nl_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "no") return no_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "pl") return pl_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "pt") return pt_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "ro") return ro_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "fi") return fi_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "sv") return sv_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "vi") return vi_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "tr") return tr_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "cs") return cs_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "bg") return bg_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "ru") return ru_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "uk") return uk_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "ar") return ar_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "hi") return hi_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "th") return th_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "ja") return ja_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_typesofchanges3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_typesofchanges3(inputs)
	return ko_components_changelogcharts_typesofchanges3(inputs)
});
export { components_changelogcharts_typesofchanges3 as "components.changelogCharts.typesOfChanges" }